import { Injectable } from '@angular/core';
import { ShopsAvailable } from '@availability/const';
import { AvailabilityActions, OccShopsService } from '@availability/data-access';
import { CityActions } from '@city/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class ShopsAvailableEffects {
  loadShopsAvailable$: Observable<
    AvailabilityActions.LoadShopsAvailableSuccess | AvailabilityActions.LoadShopsAvailableFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(AvailabilityActions.LOAD_SHOPS_AVAILABLE),
      mergeMap((action: AvailabilityActions.LoadShopsAvailable) => {
        const { productCode, unitCode } = action;

        return this.occShopsService.loadByProduct(productCode, unitCode).pipe(
          map(
            (payload: ShopsAvailable) =>
              new AvailabilityActions.LoadShopsAvailableSuccess(productCode, unitCode, payload),
          ),
          catchError((e: unknown) => of(new AvailabilityActions.LoadShopsAvailableFail(productCode, unitCode, e))),
        );
      }),
    ),
  );

  changeBaseStore$: Observable<AvailabilityActions.ResetShopsAvailable> = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.SET_ACTIVE_BASE_STORE),
      map(({ payload }) => payload),
      distinctUntilChanged(),
      map(() => new AvailabilityActions.ResetShopsAvailable()),
    ),
  );

  constructor(
    private actions$: Actions,
    private occShopsService: OccShopsService,
  ) {}
}
